import {$qsAll} from '../../@shared/ts/dom';
import {type IResponse} from '../../@type/response';

declare const peachpay_admin: PeachPayAdminData;

function handleGatewayButtonAjax() {
	$qsAll<HTMLElement>('.gateway .buttons-container .activate-button, .gateway .buttons-container .deactivate-button', $gatewayButton => {
		$gatewayButton.addEventListener('click', async () => {
			if (!$gatewayButton?.dataset?.['id']) {
				return;
			}

			// UI: loading state
			$gatewayButton.classList.add('loading');

			const formData = new FormData();

			formData.append('action', 'woocommerce_toggle_gateway_enabled');
			formData.append('security', peachpay_admin.nonces.gateway_toggle);
			formData.append('gateway_id', $gatewayButton.dataset['id']);

			const response = await fetch(peachpay_admin.admin_ajax, {
				method: 'POST',
				body: formData,
			});

			const json = await response.json() as IResponse<boolean | string>;

			const $optionsContainer = $gatewayButton.closest('.buttons-container');
			const $location_status = $gatewayButton.closest('.gateway')?.querySelector('.location-status');
			const $general_status = $gatewayButton.closest('.gateway')?.querySelector('.general-status');
			const $manage_button = $optionsContainer?.querySelector('.manage-button');
			if (json.success) {
				if (json.data as boolean) {
					$optionsContainer?.classList.add('enabled');
					$optionsContainer?.classList.remove('disabled');
					$general_status?.classList.add('active');
					$general_status?.classList.remove('inactive');
					$location_status?.classList.remove('hide');
					$manage_button?.classList.add('button-primary-filled-medium', 'default-filled');
					$manage_button?.classList.remove('button-primary-text-medium', 'default-text');
				} else {
					$optionsContainer?.classList.remove('enabled');
					$optionsContainer?.classList.add('disabled');
					$general_status?.classList.remove('active');
					$general_status?.classList.add('inactive');
					$location_status?.classList.add('hide');
					$manage_button?.classList.remove('button-primary-filled-medium', 'default-filled');
					$manage_button?.classList.add('button-primary-text-medium', 'default-text');
				}
			}

			// UI: stop loading state
			$gatewayButton.classList.remove('loading');
		});
	},
	);
}

export {
	handleGatewayButtonAjax,
};
